import React from 'react';
// import { useHistory } from 'react-router-dom';
// import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useNavigate, useLocation } from 'react-router-dom';
// import { HeadingAndText} from 'glic-ui-components'
import {TextLink } from 'glic-ui-components'


const NavMenu = () => {
  let navigate = useNavigate();
  let location = useLocation();
  // const NavigateToForm = () => {
  //   navigate("/GrievanceForm");

  // }
  const NavigateToHome = () => {
    navigate("/");
  }
  const gotoFindProvider = () => {
    window.open("https://www.guardiananytime.com/fpapp/search",
      "_blank", "width=900, height=600");
  }


  const gotohomePage = () => {
    navigate("/");
  }
  return (
    <div style={{ width: '100%', backgroundColor: '#fff' }}>
      <div className="navbar navbar-expand-lg navbar-light" style={{ padding: '0.5rem 1rem' }}>
        <div className="container-fluid d-flex align-items-center justify-content-between" style={{ paddingLeft: '.25em' }}>
          <h1 className="sr-only">Managed Dental Care</h1>

          <div className="d-flex align-items-center">

            <a className="navbar-brand d-flex align-items-center customLink" href='/' onClick={NavigateToHome} title="Managed dental care logo">
              <img src="./images/MDCLogo.drawio.svg" alt="On click you will be navigated to home page" width="320px" style={{ objectFit: 'contain', marginTop: '-0.5rem' }} />
            </a>

            {location.pathname === "/GrievanceForm" && (
              <a
                className="nav-link ms-3 d-inline-block customLink"
                id="login" href='/'
                onClick={gotohomePage}
                style={{ whiteSpace: 'nowrap' }}
              >
                Home
              </a>
              
            )}
        </div>

      </div>
    </div>
    </div >
  )
};

export default NavMenu;
